document.addEventListener('DOMContentLoaded', function () {
    var drawerBtn = document.querySelector('.drawer_open');
    var aside = document.querySelector('aside');

    if (drawerBtn && aside) {
        drawerBtn.addEventListener('click', function () {
            drawerBtn.classList.toggle('is_open');
            aside.classList.toggle('is_open');
        });
    }

    // View Transition API for works archive to single
    if (document.startViewTransition) {
        var worksLinks = document.querySelectorAll('a[data-view-transition]');
        worksLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                var href = this.getAttribute('href');
                
                document.startViewTransition(function () {
                    window.location.href = href;
                });
            });
        });
    }
});
